import { render, staticRenderFns } from "./DataRecordAddForm.vue?vue&type=template&id=77280524&scoped=true&"
import script from "./DataRecordAddForm.vue?vue&type=script&lang=js&"
export * from "./DataRecordAddForm.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordAddForm.vue?vue&type=style&index=0&id=77280524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77280524",
  null
  
)

export default component.exports